import { render, staticRenderFns } from "./CommonListPage.vue?vue&type=template&id=4a908b84&scoped=true&lang=pug&"
import script from "./CommonListPage.vue?vue&type=script&lang=js&"
export * from "./CommonListPage.vue?vue&type=script&lang=js&"
import style0 from "./CommonListPage.vue?vue&type=style&index=0&id=4a908b84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a908b84",
  null
  
)

export default component.exports